module.exports = __webpack_public_path__ + "img/bilge-pump-off-icon.ba3a9959.svg";